import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router';

import config from 'config';

// Wraps <Routes> so navigations are reported as parameterized transactions
// (ie. /customers/:customerId rather than /customers/123).
// Every <Routes> in the app should use this, including nested ones.
export const SentryRoutes = Sentry.wrapReactRouterRouting(Routes);

export const setSentryAgentInfo = (agent = {}) => {
  Sentry.setUser({ email: agent.email, name: agent.name, roles: agent.roles });
};

Sentry.init({
  dsn: 'https://1ba6ed3a5680838e1c8381d6aa5e97c3@o543490.ingest.us.sentry.io/4508286874812416',
  enabled: config.ENVIRONMENT !== 'local',
  environment: config.ENVIRONMENT,
  integrations: [
    Sentry.reactRouterBrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 1.0,
});

Sentry.setTags({
  'commit-id': process.env.REACT_APP_GIT_COMMIT ?? 'development',
});
